import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { message } from "antd";

import { QuestionnaireAction } from "../../store/actions";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  Loader,
} from "../../components";

import { UtilityArrays } from "../../config";

import "./styles.css";

const Financial = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const { questionnaire, isLoading } = useSelector(
    (state) => state?.questionnaire
  );

  const [state, setState] = useState({
    knowBudgetRange: null,
    budgetRange: null,
    budgetImportance: null,
    scholarshipImportance: null,
    scholarshipImportancePerc: null,
  });

  useEffect(() => {
    getQuestionnaire();
  }, [profileData]);

  useEffect(() => {
    setState({
      knowBudgetRange: questionnaire?.knowBudgetRange ?? null,
      budgetRange: questionnaire?.budgetRange ?? null,
      budgetImportance: questionnaire?.budgetImportance ?? null,
      scholarshipImportance: questionnaire?.scholarshipImportance ?? null,
      scholarshipImportancePerc:
        questionnaire?.scholarshipImportancePerc ?? null,
    });
  }, [questionnaire]);

  const getQuestionnaire = () => {
    dispatch(QuestionnaireAction.getQuestionnaire());
  };

  const handleNext = () => {
    if (
      !state.knowBudgetRange ||
      !state.budgetImportance ||
      !state.scholarshipImportance
    ) {
      message.error("Please fill all the fields.");
    } else {
      const payload = { userId: profileData?.id, ...state };

      dispatch(
        QuestionnaireAction.addQuestionnaire(payload, (res) => {
          if (res.status === 200) {
            navigate("/profile-builder/people");
          }
          getQuestionnaire();
        })
      );
    }
  };

  return (
    <div className="text-black">
      <div className="header-md pl-2 flex gap-2 items-center">Financial</div>
      <Spacer height={10} />
      {isLoading ? (
        <Loader.Circular />
      ) : (
        <boxContainer.LiteBoxContainer>
          <questionnaireComponents.QuestionnaireLabel
            text="1. Do you know what your ideal annual budget range for tution fee is?"
            required
          />
          <Spacer height={10} />
          <div className="pl-3">
            <inputFields.HorizontalRadio
              onChange={(e) =>
                setState({ ...state, knowBudgetRange: e.target.value })
              }
              value={state.knowBudgetRange}
              items={[
                { label: "Yes", value: "yes" },
                { label: "No", value: "no" },
              ]}
            />
          </div>
          <Spacer height={24} />

          <questionnaireComponents.QuestionnaireLabel text="2. What is your ideal annual budget range for university tution fee?" />
          <Spacer height={5} />
          <div className="w-[31.25em]">
            <inputFields.SelectDropdown
              style={{ width: "50%", paddingLeft: "0.75em" }}
              onChange={(e) => setState({ ...state, budgetRange: e })}
              placeholder="Search here"
              value={state?.budgetRange}
              items={UtilityArrays?.budgetRange}
            />
          </div>
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel
            text="3. How important is it for the university fees to be within your
          budget?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.budgetImportance}
            handleChange={(e) => setState({ ...state, budgetImportance: e })}
          />
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel
            text="4. How important are university scholarships for you?"
            required
          />
          <Spacer height={10} />
          <questionnaireComponents.QuestionnaireCircleInput
            value={state?.scholarshipImportance}
            handleChange={(e) =>
              setState({ ...state, scholarshipImportance: e })
            }
          />
          <Spacer height={24} />
          <questionnaireComponents.QuestionnaireLabel text="5. What is the minimum percentage of scholarship that you prefer?" />
          <Spacer height={10} />
          <div className="pl-3 w-[31.25em]">
            <inputFields.DefaultInput
              onChange={(e) => {
                const value = e.target.value;
                if (value >= 0 && value <= 100) {
                  setState({
                    ...state,
                    scholarshipImportancePerc: value,
                  });
                } else {
                  message.error("Please enter a value between 0 and 100.");
                }
              }}
              placeholder="Enter value"
              value={state?.scholarshipImportancePerc}
              type="number"
            />
          </div>
          <Spacer height={20} />
          <div className="flex justify-end">
            <div className="w-[12.5em]">
              <Buttons.DefaultButton
                onClick={handleNext}
                size="large"
                width="full"
              >
                Next
              </Buttons.DefaultButton>
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      )}
    </div>
  );
};

export default Financial;
